<div class="text-center" style="margin-top: 250px; margin-bottom: 400px">
  <div style="margin-left: auto; margin-right: auto;">
    <span style="font-size: xx-large; font-weight: bold">{{ message }}</span>
  </div>
</div>
